import type { CreateEventHeaderLayoutSettings } from '@graphql/generated-base';
import { v4 as uuidv4 } from 'uuid';

const DEFAULT_WELCOME_PHOTO_URL = 'https://withjoy.com/assets/public/defaultwebsitephotos/welcome_v1.jpeg?rendition=xlarge&isDefault=true';

const ALOHA_CENTER_SCHEMA_URL = 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json';

export const getAlohaCenterHeaderLayout = (): Readonly<CreateEventHeaderLayoutSettings> =>
  ({
    schemaURL: ALOHA_CENTER_SCHEMA_URL,
    dataJSON: {
      $id: ALOHA_CENTER_SCHEMA_URL,
      presentationLayout: 'center',
      photos: [
        {
          id: uuidv4(),
          url: DEFAULT_WELCOME_PHOTO_URL,
          height: 829,
          width: 1920,
          alignment: { alignX: 'center', alignY: 'center' },
        },
      ],
    },
    websiteLayout: 'aloha',
  }) as const;
